import classNames from 'classnames';

import ScreenReaderOnly from '../../../ScreenReaderOnly';
import { NexaColorizedIcon } from '../../../../icons';

import styles from './_index.module.scss';

interface ResponseProgressProps {
  isFading: boolean;
  message: string;
}

const ResponseProgress = ({ isFading, message }: ResponseProgressProps) => (
  <div
    aria-atomic="true"
    className={styles['response-progress']}
    data-testid="chat-response-progress"
    role="status"
  >
    <span aria-hidden="true" className={styles['response-progress-icon']}>
      <NexaColorizedIcon />
    </span>
    <ScreenReaderOnly>Nexa is working</ScreenReaderOnly>
    <span
      aria-hidden="true"
      className={classNames(styles['response-progress-copy'], {
        [styles['is-fading']]: isFading,
      })}
      data-testid="chat-response-progress-copy"
    >
      {message}
    </span>
  </div>
);

export default ResponseProgress;
